/* eslint-disable func-names */
/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from '@mui/styles';
import Fab from '@mui/material/Fab';
import Container from '@mui/material/Container';
import AddIcon from '@mui/icons-material/Add';
import { useRecoilState } from 'recoil';
import { useIntl } from 'react-intl';
import NewPj from './NewPj';
import { editAtom } from '../Atoms';

const useStyles = makeStyles({
  fab: {
    position: 'fixed',
    width: 'inherit',
    height: 'inherit',
    bottom: '1vh',
    right: '1vw',
    alignItems: 'center',
  },
  flBtn: {
    bottom: '0vh',
    right: '0vw',
    position: 'absolute',
  },
});

const Add = function ({ add, setAdd }) {
  const classes = useStyles();
  const [editDialog, setEditDialog] = useRecoilState(editAtom);
  const intl = useIntl();
  return (
    <Container className={classes.fab}>
      <Fab color="primary" size="large" className={classes.flBtn} onClick={() => setAdd()}>
        <AddIcon />
      </Fab>
      <NewPj
        add={editDialog || add}
        close={editDialog ? () => setEditDialog(null) : () => setAdd()}
        edit={editDialog && intl.messages.EDIT}
      />
    </Container>
  );
};

export default Add;
